import firebase from "firebase";

//Development-Production
const configDev = {
  apiKey: "AIzaSyBYI2Akb8AEJc0iRca57ojA5ymyfe_cCoQ",
  authDomain: "belfastpilates-development.firebaseapp.com",
  databaseURL: "https://belfastpilates-development.firebaseio.com",
  projectId: "belfastpilates-development",
  storageBucket: "belfastpilates-development.appspot.com",
  messagingSenderId: "931056112192",
};

const configProd = {
  apiKey: "AIzaSyDRt9qBlgypvfUVhIhnCfmPQ8vTJVOGCRs",
  authDomain: "belfastpilates-production.firebaseapp.com",
  databaseURL: "https://belfastpilates-production.firebaseio.com",
  projectId: "belfastpilates-production",
  storageBucket: "belfastpilates-production.appspot.com",
  messagingSenderId: "576556259917",
};

let config = configDev;

// console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === "production") {
  config = configProd;
} else if (process.env.NODE_ENV === "development") {
  config = configDev;
} else {
  config = configDev;
}

firebase.initializeApp(config);

export const ref = firebase.database().ref();
export const firebaseAuth = firebase.auth;



// WEBPACK FOOTER //
// ./src/common/config/constants.js